// extracted by mini-css-extract-plugin
module.exports = {"noticeBlock":"styles_noticeBlock__mPvrs"};